 const CSR_TYPE_SHORT_CODES = [
  { type: "Breakdown", shortCode: "BD" },
  { type: "Maintenance", shortCode: "MT" },
  { type: "General check", shortCode: "GC" },
  { type: "Tower re-torque", shortCode: "TR" },
];
export default CSR_TYPE_SHORT_CODES;